import { useEffect, useState } from 'react';
import { supabase } from '../supabase.js';
import { loadRoadmap } from './adminData.js';

const cellText = (value) => (value == null ? '' : String(value));

/**
 * The Roadmap tab: one table kept in the database (admin.roadmap, a row per task) and changed there, so a new column or row shows up
 * here without a new release. Shown as it is, in its own order.
 */
export default function RoadmapTab() {
  const [state, setState] = useState({ roadmap: null, error: '' });

  useEffect(() => {
    let live = true;
    loadRoadmap(supabase).then(
      (roadmap) => { if (live) setState({ roadmap, error: '' }); },
      (cause) => { if (live) setState({ roadmap: null, error: cause.message || 'Could not load the roadmap. Please try again.' }); },
    );
    return () => { live = false; };
  }, []);

  const { roadmap, error } = state;
  if (error) return <p className="mod-error" role="alert">{error}</p>;
  if (!roadmap) return <p>Loading the roadmap…</p>;
  const columns = Array.isArray(roadmap.columns) ? roadmap.columns.map(cellText) : [];
  const items = Array.isArray(roadmap.items) ? roadmap.items : [];
  if (columns.length === 0) return <p className="admin-empty">Nothing on the roadmap yet.</p>;
  return (
    <div className="mod-table-wrap">
      <table className="mod-audit roadmap">
        <thead><tr>{columns.map((name) => <th key={name} scope="col">{name}</th>)}</tr></thead>
        <tbody>
          {items.map((item, row) => (
            // The rows have no ids of their own: their place in the list is what they are.
            <tr key={row}>{columns.map((name) => <td key={name}>{cellText(item?.[name])}</td>)}</tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
